export default "__VITE_ASSET__Ddt3tcq6__"